module.exports = __webpack_public_path__ + "static/media/img_product_notice_bdan.2a0a94d0.webp";